module.exports = __webpack_public_path__ + "static/media/portfolio1.ea8e7ef4.PNG";